import { useUser } from 'hooks/user/useUser'
import { useYoloModal } from 'lib/yoloModals/useYoloModal'
import { ProfilePanelHeaderCSS } from './ProfilePanelHederCSS.styled'
import { useLayoutV3State } from 'hooks/useLayoutV3State'
import { WalletConnect } from 'components/Molecules/WalletManager/WalletConnect'
import { SingleContentToggle } from 'components/Atoms/SingleContentToggle'

const userProfileModalObj = {
  show: true,
  id: 'userProfile',
  backdropBlurred: false,
}

export const ProfilePanelHeader = () => {
  const { account } = useUser('wallet')
  const { username, avatar } = useUser('profile')
  const { updateModal } = useYoloModal()
  const { isOpenLeftPanel, setOpenLeftPanel } = useLayoutV3State()

  const showUserProfileModal = () => {
    if (account) updateModal(userProfileModalObj)
    else setOpenLeftPanel(true)
  }

  return (
    <ProfilePanelHeaderCSS className={`profile_wrapper ${isOpenLeftPanel ? 'open' : ''}`}>
      <div className='user' onClick={showUserProfileModal}>
        <SingleContentToggle
          noWrapper
          toggle={Boolean(account)}
          falseContent={
            <>
              {isOpenLeftPanel && <WalletConnect />}
              {!isOpenLeftPanel && (
                <div className='profile_avatar'>
                  <img src={avatar} alt='avatar' width='30px' />
                </div>
              )}
            </>
          }
          trueContent={
            <>
              <div className='profile_avatar'>
                <img src={avatar} alt='avatar' width='30px' />
              </div>
              <div className='profile_name'>
                <span>{username}</span>
              </div>
            </>
          }
        />
      </div>
    </ProfilePanelHeaderCSS>
  )
}
